import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

const AppContext = createContext(null);
export const useApp = () => useContext(AppContext);

export function AppProvider({ children }) {
  const [cart, setCart] = useState(() => {
    try { return JSON.parse(localStorage.getItem("cart")) || []; } catch { return []; }
  });
  const [cartOpen, setCartOpen] = useState(false);
  const [connexionOpen, setConnexionOpen] = useState(false);
  const [admin, setAdmin] = useState(null);
  const [portalUser, setPortalUser] = useState(null);

  const refreshPortal = () =>
    api.get("/portal/me").then((r) => setPortalUser(r.data)).catch(() => setPortalUser(false));

  useEffect(() => { localStorage.setItem("cart", JSON.stringify(cart)); }, [cart]);

  useEffect(() => {
    api.get("/auth/me").then((r) => setAdmin(r.data)).catch(() => setAdmin(false));
    refreshPortal();
  }, []);

  const addToCart = (product) => {
    setCart((prev) => {
      const found = prev.find((i) => i.lookup_key === product.lookup_key);
      if (found) return prev.map((i) => i.lookup_key === product.lookup_key ? { ...i, quantity: i.quantity + 1 } : i);
      return [...prev, { ...product, quantity: 1 }];
    });
    toast.success(`${product.name} ajouté au panier`);
    setCartOpen(true);
  };
  const updateQty = (lk, qty) => {
    if (qty <= 0) return removeItem(lk);
    setCart((prev) => prev.map((i) => i.lookup_key === lk ? { ...i, quantity: qty } : i));
  };
  const removeItem = (lk) => setCart((prev) => prev.filter((i) => i.lookup_key !== lk));
  const setItemFamiliar = (lk, familiar) =>
    setCart((prev) => prev.map((i) => (i.lookup_key === lk ? { ...i, familiar } : i)));
  const clearCart = () => setCart([]);
  const cartCount = cart.reduce((s, i) => s + i.quantity, 0);
  const cartTotal = cart.reduce((s, i) => s + i.price * i.quantity, 0);

  return (
    <AppContext.Provider value={{ cart, cartOpen, setCartOpen, addToCart, updateQty, removeItem, setItemFamiliar, clearCart, cartCount, cartTotal, admin, setAdmin, connexionOpen, setConnexionOpen, portalUser, setPortalUser, refreshPortal }}>
      {children}
    </AppContext.Provider>
  );
}
